import { useEffect } from "react";
import CategoryDetailTemplate from "../../../Templetes/Categories/Details/CategoryDetail.template";

const RobomissionPage = () => {
  useEffect(() => {
    document.title = "We Do Challenge - Robomission Challenge";
  }, []);
  return <CategoryDetailTemplate />;
};

export default RobomissionPage;
